module.exports = __webpack_public_path__ + "static/img/youhuiquanx.caa07551.png";